import React, { ComponentPropsWithRef } from 'react';
import { cn } from '../platform/dom/cn';

export function LoadingSpinner({
  className,
  color = 'currentColor',
  ...props
}: ComponentPropsWithRef<'svg'> & { color?: string }) {
  return (
    // Size as attributes, not a class: any CSS beats them, so a button's icon
    // size (`:where`) applies, and alone it is still `size-5`.
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 50 50"
      fill="none"
      stroke={color}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('animate-spin', className)}
      {...props}
    >
      <circle cx="25" cy="25" r="20" strokeOpacity="0.2" />
      <path d="M25 5a20 20 0 0 1 20 20" stroke={color} />
    </svg>
  );
}
